module.exports = __webpack_public_path__ + "static/media/cam32_concat.18ba079f.jpg";